import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import type { NodeSpec } from './NodeSpec';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const workInstructionStatusUiNodeSpec: NodeSpec<NodeCfg<'workInstructionStatus'>> = {
    cfg: () => ({ id: getUID(), kind: 'workInstructionStatus', width: 240, controlValues: { workInstructionVersionId: '' } }),
    controls: nodeCfg => ({
        workInstructionVersionId: defineControlOpts({
            cfg: {
                kind: 'selectWorkInstructionVersion',
                label: 'Work Instruction',
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.workInstructionVersionId,
        }),
    }),
    inputs: () => ({
        trigger: { socket: 'event', label: 'Trigger' },
        materialId: { socket: 'string', label: 'Material ID' },
    }),
    kindLabel: 'Work Instruction Status',
    nodeCategory: 'argonautApi',
    outputs: () => ({
        next: { socket: 'event', label: 'Next' },
        status: { socket: 'string', label: 'Status' },
        totalSteps: { socket: 'number', label: 'Total Steps' },
        completedSteps: { socket: 'number', label: 'Completed Steps' },
    }),
    requiredSockets: (_node, _availableInputSockets, availableOutputSockets) => ({
        required: [ 'trigger', 'materialId', 'next' ],
        conditionallyRequired: [ {
            kind: 'or',
            availableOptions: availableOutputSockets.filter(socket => ![ 'trigger', 'materialId', 'next' ].includes(socket)),
        } ],
    }),
    validator: node => node.controlValues.workInstructionVersionId
        ? true
        : { workInstructionVersionId: 'Work Instruction ID is required' },
};
